// extracted by mini-css-extract-plugin
export default {"toggle":"_2bm6_","tooltip":"_2JGML","badge-icon":"_1i3Lk","badgeIcon":"_1i3Lk"};